const checkZeroValidity = (validity: number) => {
    return validity === 0 ? '-' : validity.toString();
};
export const renderValidity = (validity: number) => checkZeroValidity(validity);
